import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function Plus({
  size = MAIN_THEME.iconSize.small,
  color = MAIN_THEME.colors.brandGray30,
}: ISvgProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.3244 7.78841H9.75734V1.19119C9.75734 1.00894 9.6104 0.861328 9.42898 0.861328H8.11558C7.93416 0.861328 7.78723 1.00894 7.78723 1.19119V7.78841H1.2202C1.03878 7.78841 0.891846 7.93602 0.891846 8.11827V9.43772C0.891846 9.61997 1.03878 9.76758 1.2202 9.76758H7.78723V16.3648C7.78723 16.547 7.93416 16.6947 8.11558 16.6947H9.42898C9.6104 16.6947 9.75734 16.547 9.75734 16.3648V9.76758H16.3244C16.5058 9.76758 16.6527 9.61997 16.6527 9.43772V8.11827C16.6527 7.93602 16.5058 7.78841 16.3244 7.78841Z"
        fill={color}
      />
    </svg>
  );
}
